<template>
  <v-container
    class="px-0 py-0 page-login"
    fluid>
    <v-layout
      row
      wrap
      align-center>
      <v-flex
        xs12
        sm12
        md12
        tag="section"
        class="login-area"
        align-center>
        <slot />
      </v-flex>
      <!-- <v-footer
        :absolute=true
        class="pa-3"
        color="transparent justify-center">
        <img
          src="@/assets/images/mais_solucoes_horizontal.svg"
          class="logo-footer"
          alt="logo Mais Soluções">
        <div class="caption ml-3 mediumGray--text">
          Copyright &copy; {{ new Date().getFullYear() }} modera.app
          <br>
          Todos os direitos reservados
        </div>
      </v-footer> -->
    </v-layout>
  </v-container>
</template>

<script>
  import validate from '@/mixins/validate'
  import { mapGetters } from 'vuex'

  export default {
    name: 'NotAuthenticated',
    mixins: [ validate ],
    computed: {
      ...mapGetters('app', ['logo'])
    }
  }
</script>

<style lang="sass">
  @import '../assets/style/login'
</style>
